<template>
	<a
		role="menuitem"
		class="menu-list-item gap-3 py-3 px-4 bg-transparent cursor-pointer"
		:href="url"
		:class="[textColor, disabled ? 'disabled' : '']"
	>
		<div class="d-flex gap-1 align-center" :disabled="disabled">
			<Icon v-if="icon" :icon="icon" />
			<NewIcon v-if="newIcon" :icon="newIcon" />
			<p class="text-body-m">
				{{ name }}
			</p>
		</div>
	</a>
</template>

<script setup lang="ts">
	import Icon from './Icon.vue'
	import NewIcon from './NewIcon.vue'

	interface Props {
		name: string
		url?: string
		textColor?: string
		icon?: string
		newIcon?: string
		disabled?: boolean
	}

	withDefaults(defineProps<Props>(), {
		textColor: 'text-neutral-800',
		url: '#',
		icon: '',
		newIcon: '',
	})
</script>

<style scoped lang="scss">
	.menu-list-item {
		&:hover {
			background-color: var(--color-neutral-100);
		}
	}

	.disabled {
		pointer-events: none;
		color: gray;
		cursor: not-allowed;
		text-decoration: none;
		opacity: 0.6;
	}
</style>
